(function () {
  var STORAGE_KEY = 'ycj_newsletter_status';

  function isSubscribed() {
    try { return localStorage.getItem(STORAGE_KEY) === 'subscribed'; } catch (e) { return false; }
  }

  function setSubscribed() {
    try { localStorage.setItem(STORAGE_KEY, 'subscribed'); } catch (e) {}
  }

  function showSubscribed() {
    document.querySelectorAll('[data-newsletter-form]').forEach(function (el) {
      el.classList.add('is-hidden');
    });
    document.querySelectorAll('[data-newsletter-success]').forEach(function (el) {
      el.classList.remove('is-hidden');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Shopify just rendered the success state for this request (native
    // "customer" form submit) — persist it so it survives future visits too.
    if (document.querySelector('[data-just-subscribed]')) setSubscribed();

    
  });

  // Fires from ycj-newsletter-onboarding.js when the onboarding form/inline
  // section elsewhere on the page just marked the visitor as subscribed, so
  // the footer reflects it without needing a page reload.
  document.addEventListener('ycj:newsletter-status-changed', function (e) {
    if (e.detail && e.detail.status === 'subscribed') showSubscribed();
  });
})();
